import React, { ReactNode } from 'react';

import { Currency } from '../../types/module';

import { EmployeePriceFeaturedTemplate } from './templatePrice/EmployeePriceFeaturedTemplate';
import { TotalPriceFeaturedTemplate } from './templatePrice/TotalPriceFeaturedTemplate';
import { classNames } from '../../utils/style';

export interface PriceProps {
  price: number;
  previousPrice?: number;
  abonnementPrice?: number;
  abonnementPriceLabel?: string;
  pricePerEmployee?: number;
  previousPricePerEmployee?: number;
  PricePerEmployee?: ReactNode;
  pricePerEmployeeLabel?: ReactNode;
  extraPrice?: number;
  extraPriceLabel?: string;
  extraPriceLineThrough?: boolean;
  installationLabel?: ReactNode;
  installationLineThrough?: boolean;
  currency?: Currency;
  prefixTotal?: string;
  sufixTotal?: string;
  className?: string;
  displayEmptyLines?: string[];
  locale?: string;
  template?: 'EmployeePriceFeaturedTemplate' | 'TotalPriceFeaturedTemplate';
  currencyFirst?: boolean;
}

export const Price = ({
  className,
  pricePerEmployeeLabel = '',
  extraPriceLabel = '',
  prefixTotal = '',
  sufixTotal = '',
  extraPriceLineThrough = false,
  installationLineThrough = false,
  locale = 'fr',
  template = 'TotalPriceFeaturedTemplate',
  ...args
}: PriceProps) => {
  const currencyFirst = ['en'].includes(locale);

  const priceData = {
    ...args,
    pricePerEmployeeLabel,
    extraPriceLabel,
    prefixTotal,
    sufixTotal,
    extraPriceLineThrough,
    installationLineThrough,
    currencyFirst,
  };

  return (
    <div
      className={classNames(
        'PricingCardPricingCard',
        'font-sans',
        'text-neutral-301 mb-8 text-14',
        className,
      )}
    >
      {template === 'EmployeePriceFeaturedTemplate' && (
        <EmployeePriceFeaturedTemplate {...priceData} />
      )}
      {template === 'TotalPriceFeaturedTemplate' && (
        <TotalPriceFeaturedTemplate {...priceData} />
      )}
    </div>
  );
};
